import { useLoadingAnimation } from '@/components/LoadingAnimation/useLoadingAnimation.hook';
import { DEFAULT_ERROR_MESSAGE } from '@/config/text.const';
import { useSaveFileLocally } from '@/hooks/useSaveFileLocally.hook';
import { importingToolHttpClient } from '@/services/http/clients/importingToolHttpClient';
import { HttpStatusCode } from '@/services/http/HttpStatusCodes';
import { notificationService } from '@/services/notification/notification.client';

export function useGetImportingToolTemplate() {
  const { toggleLoadingAnimation } = useLoadingAnimation();
  const { saveFileLocally, getFileNameFromContentDisposition } = useSaveFileLocally();

  const getTemplate = async () => {
    toggleLoadingAnimation(true);

    try {
      const response = await importingToolHttpClient.get('/download-document-template', {
        responseType: 'arraybuffer',
      });
      if (response?.status === HttpStatusCode.OK) {
        const blob = new Blob([response.data]);
        const fileName = getFileNameFromContentDisposition(response.headers['content-disposition']);
        saveFileLocally(blob, fileName);
      }
    }
    catch (err: any) {
      notificationService.open({
        title: 'Error',
        text: err?.message ?? DEFAULT_ERROR_MESSAGE,
        type: 'danger'
      });
    }
    finally {
      toggleLoadingAnimation(false);
    }
  };

  return {
    getTemplate
  } as const;
}
